var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { cloneElement } from 'react';
/**
 * @deprecated use styled-components to control margin instead
 */
export var Margin = function (_a) {
  var children = _a.children,
    top = _a.top,
    right = _a.right,
    bottom = _a.bottom,
    left = _a.left,
    props = __rest(_a, ["children", "top", "right", "bottom", "left"]);
  var marginTop = top ? Number(top) + 'px' : undefined;
  var marginRight = right ? Number(right) + 'px' : undefined;
  var marginBottom = bottom ? Number(bottom) + 'px' : undefined;
  var marginLeft = left ? Number(left) + 'px' : undefined;
  var style = {
    marginTop: marginTop,
    marginRight: marginRight,
    marginBottom: marginBottom,
    marginLeft: marginLeft
  };
  return cloneElement(children, __assign({
    style: style
  }, props));
};